export let getAllFreeWifiPackages =
    {
        "responseHeader": {
            "statusCode": "SUCCESS",
            "clientTransactionId": "2f687b91-c8a1-4c6b-887a-2f4d6cddac92",
            "serverTransactionId": "df9916db-b4bb-4826-8a8b-beec47581493"
        },
        "messageList": [],
        "data": [
            {
                "id": "521",
                "name_tr": "Sınırsız İnternet",
                "name_en": "Unlimited Internet",
                "description_tr": "Miles&Smiles Elite veya Elite Plus Program Üyesi Business Class Yolcularımız",
                "description_en": "Our Business Class passengers who are Miles&Smiles Elite or Elite Plus Program members",
                "flightType": "INT",
                "flightRange": "LONG",
                "freePackageStatus": "FREE_BUSINESS",
                "quotaType": "VOLUME",
                "packageType": "INTERNET",
                "amount": 1,
                "unit": "GB",
                "isUnlimited": false,
                "packageNames": [
                    {
                        "text": "Sınırsız İnternet",
                        "locale": "TR"
                    },
                    {
                        "text": "Unlimited Internet",
                        "locale": "EN"
                    },
                    {
                        "text": "Neogranichenniy internet",
                        "locale": "RU"
                    },
                    {
                        "text": "Unbegrenztes Internet",
                        "locale": "DE"
                    },
                    {
                        "text": "Internet illimité",
                        "locale": "FR"
                    },
                    {
                        "text": "Internet ilimitado",
                        "locale": "ES"
                    }
                ],
                "packageInfos": [
                    {
                        "text": "Business Yolcularına 1 GB İnternet",
                        "locale": "TR"
                    },
                    {
                        "text": "1 GB Internet for Business Passengers",
                        "locale": "EN"
                    },
                    {
                        "text": "1 GB Internet dlya biznes-passazhirov",
                        "locale": "RU"
                    },
                    {
                        "text": "1 Go d'Internet pour les passagers Business",
                        "locale": "FR"
                    },
                    {
                        "text": "1 GB Internet für Business-Passagiere",
                        "locale": "DE"
                    },
                    {
                        "text": "1 GB de Internet para pasajeros Business",
                        "locale": "ES"
                    }
                ],
                "packageDescriptions": [
                    {
                        "text": "Business Yolcularına 1 GB İnternet",
                        "locale": "TR"
                    },
                    {
                        "text": "1 GB Internet for Business Passengers",
                        "locale": "EN"
                    },
                    {
                        "text": "1 GB Internet dlya biznes-passazhirov",
                        "locale": "RU"
                    },
                    {
                        "text": "1 Go d'Internet pour les passagers Business",
                        "locale": "FR"
                    },
                    {
                        "text": "1 GB Internet für Business-Passagiere",
                        "locale": "DE"
                    },
                    {
                        "text": "1 GB de Internet para pasajeros Business",
                        "locale": "ES"
                    }
                ],
                "packageInfoDescs": [
                    {
                        "text": "Business Yolcularına 1 GB İnternet",
                        "locale": "TR"
                    },
                    {
                        "text": "1 GB For Business Passengers",
                        "locale": "EN"
                    },
                    {
                        "text": "1 GB Internet dlya biznes-passazhirov",
                        "locale": "RU"
                    },
                    {
                        "text": "1 Go d'Internet pour les passagers Business",
                        "locale": "FR"
                    },
                    {
                        "text": "1 GB Internet für Business-Passagiere",
                        "locale": "DE"
                    },
                    {
                        "text": "1 GB de Internet para pasajeros Business",
                        "locale": "ES"
                    }
                ]
            },
            {
                "id": "1142",
                "name_tr": "Sınırsız Mesajlaşma",
                "name_en": "Unlimited Messaging",
                "description_tr": "Miles&Smiles Classic Program Üyelerimiz",
                "description_en": "Our Miles&Smiles Classic Program members",
                "flightType": "ALL",
                "flightRange": "ALL",
                "freePackageStatus": "FREE_ECONOMY",
                "quotaType": "DURATION",
                "packageType": "CHAT",
                "amount": 22,
                "unit": "HOURS",
                "isUnlimited": false,
                "packageNames": [
                    {
                        "text": "Sınırsız Mesajlaşma",
                        "locale": "TR"
                    },
                    {
                        "text": "Unlimited Messaging",
                        "locale": "EN"
                    },
                    {
                        "text": "Neogranichennoe obshcheniye",
                        "locale": "RU"
                    },
                    {
                        "text": "Messagerie illimitée",
                        "locale": "FR"
                    },
                    {
                        "text": "Unbegrenzte Nachrichten",
                        "locale": "DE"
                    },
                    {
                        "text": "Mensajería ilimitada",
                        "locale": "ES"
                    }
                ],
                "packageInfos": [
                    {
                        "text": "Sınırsız Mesajlaşma",
                        "locale": "TR"
                    },
                    {
                        "text": "Unlimited Messaging",
                        "locale": "EN"
                    },
                    {
                        "text": "Neogranichennoe obshcheniye",
                        "locale": "RU"
                    },
                    {
                        "text": "Messagerie illimitée",
                        "locale": "FR"
                    },
                    {
                        "text": "Unbegrenzte Nachrichten",
                        "locale": "DE"
                    },
                    {
                        "text": "Mensajería ilimitada",
                        "locale": "ES"
                    }
                ],
                "packageDescriptions": [
                    {
                        "text": "Uchastnikam Miles&Smiles - Neogranichennoe obshcheniye",
                        "locale": "RU"
                    },
                    {
                        "text": "Membres Miles&Smiles - Messagerie illimitée",
                        "locale": "FR"
                    },
                    {
                        "text": "Miles&Smiles-Mitglieder - Unbegrenzte Nachrichten",
                        "locale": "DE"
                    },
                    {
                        "text": "Miembros de Miles&Smiles - Mensajería ilimitada",
                        "locale": "ES"
                    },
                    {
                        "text": "Miles&Smiles Üyelerine Sınırsız Mesajlaşma",
                        "locale": "TR"
                    },
                    {
                        "text": "Unlimited Messaging for Miles&Smiles Members",
                        "locale": "EN"
                    }
                ],
                "packageInfoDescs": [
                    {
                        "text": "Uchastnikam Miles&Smiles - Neogranichennoe obshcheniye",
                        "locale": "RU"
                    },
                    {
                        "text": "Membres Miles&Smiles - Messagerie illimitée",
                        "locale": "FR"
                    },
                    {
                        "text": "Miles&Smiles-Mitglieder - Unbegrenzte Nachrichten",
                        "locale": "DE"
                    },
                    {
                        "text": "Miembros de Miles&Smiles - Mensajería ilimitada",
                        "locale": "ES"
                    },
                    {
                        "text": "Miles&Smiles Üyelerine Sınırsız Mesajlaşma",
                        "locale": "TR"
                    },
                    {
                        "text": "Unlimited Chat For Miles&Smiles Members",
                        "locale": "EN"
                    }
                ]
            },
            {
                "id": "1144",
                "name_tr": "1 GB ve Sınırsız Mesajlaşma",
                "name_en": "1 GB and Unlimited Messaging",
                "description_tr": "Business Class Yolcularımız",
                "description_en": "Our Business Class passengers",
                "flightType": "INT",
                "flightRange": "ALL",
                "freePackageStatus": "FREE_BUSINESS",
                "quotaType": "VOLUME",
                "packageType": "INTERNET",
                "amount": 1,
                "unit": "GB",
                "isUnlimited": false,
                "packageNames": [
                    {
                        "text": "1 GB ve Sınırsız Mesajlaşma",
                        "locale": "TR"
                    },
                    {
                        "text": "1 GB and Unlimited Messaging",
                        "locale": "EN"
                    },
                    {
                        "text": "1 GB i neogranichennoe obshcheniye",
                        "locale": "RU"
                    },
                    {
                        "text": "1 Go et messagerie illimitée",
                        "locale": "FR"
                    },
                    {
                        "text": "1 GB und unbegrenzte Nachrichten",
                        "locale": "DE"
                    },
                    {
                        "text": "1 GB y mensajería ilimitada",
                        "locale": "ES"
                    }
                ],
                "packageInfos": [
                    {
                        "text": "1 GB Internet",
                        "locale": "TR"
                    },
                    {
                        "text": "1 GB Internet",
                        "locale": "EN"
                    },
                    {
                        "text": "1 GB Internet",
                        "locale": "RU"
                    },
                    {
                        "text": "1 Go d'Internet",
                        "locale": "FR"
                    },
                    {
                        "text": "1 GB Internet",
                        "locale": "DE"
                    },
                    {
                        "text": "1 GB de Internet",
                        "locale": "ES"
                    }
                ],
                "packageDescriptions": [
                    {
                        "text": "Business Yolculara 1 GB Internet",
                        "locale": "TR"
                    },
                    {
                        "text": "1 GB Internet for Business Passengers",
                        "locale": "EN"
                    },
                    {
                        "text": "1 GB Internet dlya biznes-passazhirov",
                        "locale": "RU"
                    },
                    {
                        "text": "1 Go d'Internet pour les passagers Business",
                        "locale": "FR"
                    },
                    {
                        "text": "1 GB Internet für Business-Passagiere",
                        "locale": "DE"
                    },
                    {
                        "text": "1 GB de Internet para pasajeros Business",
                        "locale": "ES"
                    }
                ],
                "packageInfoDescs": [
                    {
                        "text": "Business Yolculara 1 GB Internet",
                        "locale": "TR"
                    },
                    {
                        "text": "1 GB Data For Business Passengers",
                        "locale": "EN"
                    },
                    {
                        "text": "1 GB Internet dlya biznes-passazhirov",
                        "locale": "RU"
                    },
                    {
                        "text": "1 Go d'Internet pour les passagers Business",
                        "locale": "FR"
                    },
                    {
                        "text": "1 GB Internet für Business-Passagiere",
                        "locale": "DE"
                    },
                    {
                        "text": "1 GB de Internet para pasajeros Business",
                        "locale": "ES"
                    }
                ]
            },
            {
                "id": "1145",
                "name_tr": "400 MB ve Sınırsız Mesajlaşma",
                "name_en": "400 MB and Unlimited Messaging",
                "description_tr": "Miles&Smiles Elite ve Elite Plus Program Üyelerimiz",
                "description_en": "Our Miles&Smiles Elite and Elite Plus Program members",
                "flightType": "INT",
                "flightRange": "ALL",
                "freePackageStatus": "FREE_ECONOMY",
                "quotaType": "VOLUME",
                "packageType": "INTERNET",
                "amount": 400,
                "unit": "MB",
                "isUnlimited": false,
                "packageNames": [
                    {
                        "text": "400 MB ve Sınırsız Mesajlaşma",
                        "locale": "TR"
                    },
                    {
                        "text": "400 MB and Unlimited Messaging",
                        "locale": "EN"
                    },
                    {
                        "text": "400 MB i neogranichennoe obshcheniye",
                        "locale": "RU"
                    },
                    {
                        "text": "400 Mo et messagerie illimitée",
                        "locale": "FR"
                    },
                    {
                        "text": "400 MB und unbegrenzte Nachrichten",
                        "locale": "DE"
                    },
                    {
                        "text": "400 MB y mensajería ilimitada",
                        "locale": "ES"
                    }
                ],
                "packageInfos": [
                    {
                        "text": "400 MB Internet",
                        "locale": "TR"
                    },
                    {
                        "text": "400 MB Internet",
                        "locale": "EN"
                    },
                    {
                        "text": "400 MB Internet",
                        "locale": "RU"
                    },
                    {
                        "text": "400 Mo d'Internet",
                        "locale": "FR"
                    },
                    {
                        "text": "400 MB Internet",
                        "locale": "DE"
                    },
                    {
                        "text": "400 MB de Internet",
                        "locale": "ES"
                    }
                ],
                "packageDescriptions": [
                    {
                        "text": "Elite&Elite Plus Üyelere 400 MB Internete Paketi",
                        "locale": "TR"
                    },
                    {
                        "text": "400 MB Internet Package for Elite & Elite Plus Members",
                        "locale": "EN"
                    },
                    {
                        "text": "Uchastnikam Elite & Elite Plus - Paket 400 MB Internet",
                        "locale": "RU"
                    },
                    {
                        "text": "Membres Elite & Elite Plus - Forfait 400 Mo d'Internet",
                        "locale": "FR"
                    },
                    {
                        "text": "Elite & Elite Plus-Mitgliedern - 400 MB Internet-Paket",
                        "locale": "DE"
                    },
                    {
                        "text": "Miembros de Elite & Elite Plus - Paquete de 400 MB de Internet",
                        "locale": "ES"
                    }
                ],
                "packageInfoDescs": [
                    {
                        "text": "Elite&Elite Plus Üyelere 400 MB Internete Paketi",
                        "locale": "TR"
                    },
                    {
                        "text": "400 MB Data For Elite&Elite Plus Members",
                        "locale": "EN"
                    },
                    {
                        "text": "Uchastnikam Elite & Elite Plus - Paket 400 MB Internet",
                        "locale": "RU"
                    },
                    {
                        "text": "Membres Elite & Elite Plus - Forfait 400 Mo d'Internet",
                        "locale": "FR"
                    },
                    {
                        "text": "Elite & Elite Plus-Mitgliedern - 400 MB Internet-Paket",
                        "locale": "DE"
                    },
                    {
                        "text": "Miembros de Elite & Elite Plus - Paquete de 400 MB de Internet",
                        "locale": "ES"
                    }
                ]
            },
            {
                "id": "1146",
                "name_tr": "250 MB ve Sınırsız Mesajlaşma",
                "name_en": "250 MB and Unlimited Messaging",
                "description_tr": "Miles&Smiles Classic Plus Program Üyelerimiz",
                "description_en": "Our Miles&Smiles Classic Plus Program members",
                "flightType": "INT",
                "flightRange": "ALL",
                "freePackageStatus": "FREE_ECONOMY",
                "quotaType": "VOLUME",
                "packageType": "INTERNET",
                "amount": 250,
                "unit": "MB",
                "isUnlimited": false,
                "packageNames": [
                    {
                        "text": "250 MB ve Sınırsız Mesajlaşma",
                        "locale": "TR"
                    },
                    {
                        "text": "250 MB and Unlimited Messaging",
                        "locale": "EN"
                    },
                    {
                        "text": "250 MB i neogranichennoe obshcheniye",
                        "locale": "RU"
                    },
                    {
                        "text": "250 Mo et messagerie illimitée",
                        "locale": "FR"
                    },
                    {
                        "text": "250 MB und unbegrenzte Nachrichten",
                        "locale": "DE"
                    },
                    {
                        "text": "250 MB y mensajería ilimitada",
                        "locale": "ES"
                    }
                ],
                "packageInfos": [
                    {
                        "text": "250 MB Internet",
                        "locale": "TR"
                    },
                    {
                        "text": "250 MB Internet",
                        "locale": "EN"
                    },
                    {
                        "text": "250 MB Internet",
                        "locale": "RU"
                    },
                    {
                        "text": "250 Mo d'Internet",
                        "locale": "FR"
                    },
                    {
                        "text": "250 MB Internet",
                        "locale": "DE"
                    },
                    {
                        "text": "250 MB de Internet",
                        "locale": "ES"
                    }
                ],
                "packageDescriptions": [
                    {
                        "text": "Classic Plus Üyelere 250 MB Interent Paketi",
                        "locale": "TR"
                    },
                    {
                        "text": "250 MB Internet Package for Classic Plus Members",
                        "locale": "EN"
                    },
                    {
                        "text": "Uchastnikam Classic Plus - Paket 250 MB Internet",
                        "locale": "RU"
                    },
                    {
                        "text": "Membres Classic Plus - Forfait 250 Mo d'Internet",
                        "locale": "FR"
                    },
                    {
                        "text": "Classic Plus-Mitgliedern - 250 MB Internet-Paket",
                        "locale": "DE"
                    },
                    {
                        "text": "Miembros de Classic Plus - Paquete de 250 MB de Internet",
                        "locale": "ES"
                    }
                ],
                "packageInfoDescs": [
                    {
                        "text": "Classic Plus Üyelere 250 MB Interent Paketi",
                        "locale": "TR"
                    },
                    {
                        "text": "250 MB Data For Classic Plus Members",
                        "locale": "EN"
                    },
                    {
                        "text": "Uchastnikam Classic Plus - Paket 250 MB Internet",
                        "locale": "RU"
                    },
                    {
                        "text": "Membres Classic Plus - Forfait 250 Mo d'Internet",
                        "locale": "FR"
                    },
                    {
                        "text": "Classic Plus-Mitgliedern - 250 MB Internet-Paket",
                        "locale": "DE"
                    },
                    {
                        "text": "Miembros de Classic Plus - Paquete de 250 MB de Internet",
                        "locale": "ES"
                    }
                ]
            }
        ],
        "loginStatus": null
    };
